import type { ExtendedRecordMap } from 'notion-types';
import type { Dispatch, AnyAction } from 'redux';

import type NotionResponse from 'ab-viewModels/knowledgeCenter/notionResponse.viewModel';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

import API from 'af-constants/routes/api';

export function findNotionResponse() {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.get<NotionResponse>(API.V1.KNOWLEDGE_CENTER.FIND_NOTION_RESPONSE());
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function getNotionPage(pageId: string) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {

		const action = async () => {
			return await http.get<ExtendedRecordMap>(API.V1.KNOWLEDGE_CENTER.GET_NOTION_PAGE(pageId));
		};

		return await errorHandler(action, dispatch, redirectTo);
	};
}
